import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrdenCompraRoutingModule } from './orden-compra-routing.module';
import { OrdenCompraComponent } from './orden-compra.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddOrdenCompraComponent } from './add-orden-compra/add-orden-compra.component';
import { ListarOrdenCompraComponent } from './listar-orden-compra/listar-orden-compra.component';
import { BrowserModule } from '@angular/platform-browser';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableExporterModule } from 'mat-table-exporter';
import { DialogProveedorComponent } from './add-orden-compra/dialog-proveedor/dialog-proveedor.component';
import { DialogAddItemOcComponent } from './add-orden-compra/dialog-add-item-oc/dialog-add-item-oc.component';
import { DialogShowPagosComponent } from './listar-orden-compra/dialog-show-pagos/dialog-show-pagos.component';
import { DialogShowItemsComponent } from './listar-orden-compra/dialog-show-items/dialog-show-items.component';


@NgModule({
  declarations: [
    OrdenCompraComponent,
    AddOrdenCompraComponent,
    ListarOrdenCompraComponent,
    DialogProveedorComponent,
    DialogAddItemOcComponent,
    DialogShowPagosComponent,
    DialogShowItemsComponent
  ],
  imports: [
    CommonModule,
    OrdenCompraRoutingModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    MatFormFieldModule,
    MatTableExporterModule
  ]
})
export class OrdenCompraModule { }
